jQuery(document).ready(function () {
    const buttons = document.querySelectorAll('.mobile-menu li');
    let mobile = document.querySelector('.mobile-menu--white-bg');


    for (const button of buttons) {
        if(button.querySelector('.submenu-container-mobile')) {
            button.querySelector('.submenu-container-mobile').style.height = getComputedStyle(button.querySelector('.submenu-container-mobile')).height;
            button.querySelector('.submenu-container-mobile').classList.add('submenu-container-mobile--hide');
            if(button.querySelector('.submenu-main')) {
                button.querySelector('.submenu-main').style.height = getComputedStyle(button.querySelector('.submenu-main')).height;
                button.querySelector('.submenu-main').classList.add('submenu-main--hide');
                // button.querySelector('.submenu-main').style.display = 'none';
            }
        }
    }

    for (const button of buttons) {
        if(button.querySelector('.submenu-container-mobile')) {
            button.querySelector('.link-and-dropdown').addEventListener('click', () => {
                if(button.querySelector('.submenu-container-mobile').classList.contains('submenu-container-mobile--hide')) {
                    button.querySelector('.submenu-container-mobile').classList.remove('submenu-container-mobile--hide');
                    button.querySelector('.submenu-container-mobile').scrollIntoView({behavior: 'smooth'});
                    button.querySelector('.dropdown-reveal-nav').classList.add('dropdown-reveal-nav--selected');
                    if(button.querySelector('.submenu-main')) {
                        button.querySelector('.submenu-main').classList.remove('submenu-main--hide');
                        button.querySelector('.submenu-main').style.display = '';
                    }
                    for(const but of buttons) {
                        if((but !== button) && but.classList.contains('dropdown-container')) {
                            but.querySelector('.submenu-container-mobile').scrollIntoView({behavior: 'smooth'});
                            but.querySelector('.submenu-container-mobile').classList.add('submenu-container-mobile--hide');
                            but.querySelector('.dropdown-reveal-nav').classList.remove('dropdown-reveal-nav--selected');
                            if(but.querySelector('.submenu-main')) {
                                but.querySelector('.submenu-main').classList.add('submenu-main--hide');
                                but.querySelector('.submenu-main').style.display = 'none';
                            }
                            mobile.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }
                    }
                } else {
                    button.querySelector('.submenu-container-mobile').scrollIntoView({behavior: 'smooth'});
                    button.querySelector('.submenu-container-mobile').classList.add('submenu-container-mobile--hide');
                    button.querySelector('.dropdown-reveal-nav').classList.remove('dropdown-reveal-nav--selected');
                    if(button.querySelector('.submenu-main')) {
                        button.querySelector('.submenu-main').classList.add('submenu-main--hide');
                        button.querySelector('.submenu-main').style.display = 'none';
                    }
                    mobile.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            })
        }
    }

    const submenuButtons = document.querySelectorAll('.mobile-menu--white-bg .swiper-slide a');

    const webDev = document.querySelector('.mobile-menu--white-bg .dropdown-container#web-dev');
    const eComm = document.querySelector('.mobile-menu--white-bg a#ecomm');
    const bckEnd = document.querySelector('.mobile-menu--white-bg a#backend');
    const mobDev = document.querySelector('.mobile-menu--white-bg a#mobile-dev');

    for (let i=0; i<submenuButtons.length; i++) {
        submenuButtons[i].addEventListener('click', () => {
            switch (i) {
                case 0:
                    webDev.scrollIntoView({behavior: 'smooth'});
                    break;
                case 1:
                    eComm.scrollIntoView({behavior: 'smooth'});
                    break;
                case 2:
                    bckEnd.scrollIntoView({behavior: 'smooth'});
                    break;
                case 3:
                    mobDev.scrollIntoView({behavior: 'smooth'});
            }
        })
    }

    // const inters = document.querySelectorAll('.intersection');

    const inter1 = document.querySelector('#inter1');
    const inter2 = document.querySelector('#inter2');
    const inter3 = document.querySelector('#inter3');
    const inter4 = document.querySelector('#inter4');

    let int1 = false;
    let int2 = false;
    let int3 = false;
    let int4 = false;

    const isIntersecting = [
        int1, int2, int3, int4
    ]

    function checkIntersection() {
        for (let i = 0; i <= isIntersecting.length; i++) {
            if(i<isIntersecting.length) {
                if(isIntersecting[i] === true) {
                    for (let j = 0; j < isIntersecting.length; j++) {
                        submenuButtons[j].querySelector('h2').classList.remove('selected');
                    }
                    submenuButtons[i].querySelector('h2').classList.add('selected');
                    newTechInsightSwiper.slideTo(i);
                    break;
                }
            }
        }
    }

    const obsCallback = function (entries, observer) {
        entries.forEach((entry, index) => {
            isIntersecting[0] = entry.isIntersecting;
            // entry.target.classList.toggle("selected");
        });
        // for (let i=0; i<submenuButtons.length; i++) {
        //     if(submenuButtons[i].querySelector('h2')) {
        //         if(entries[i].isIntersecting) {
        //             alert(i);
        //             submenuButtons[i].querySelector('h2').classList.toggle('selected');
        //         }
        //     }
        // }
        checkIntersection();
    }

    const obsCallback2 = function (entries, observer) {
        entries.forEach((entry, index) => {
            isIntersecting[1] = entry.isIntersecting;
            // entry.target.classList.toggle("selected");
        });
        // for (let i=0; i<submenuButtons.length; i++) {
        //     if(submenuButtons[i].querySelector('h2')) {
        //         if(entries[i].isIntersecting) {
        //             alert(i);
        //             submenuButtons[i].querySelector('h2').classList.toggle('selected');
        //         }
        //     }
        // }
        checkIntersection();
    }

    const obsCallback3 = function (entries, observer) {
        entries.forEach((entry, index) => {
            isIntersecting[2] = entry.isIntersecting;
            // entry.target.classList.toggle("selected");
        });
        // for (let i=0; i<submenuButtons.length; i++) {
        //     if(submenuButtons[i].querySelector('h2')) {
        //         if(entries[i].isIntersecting) {
        //             alert(i);
        //             submenuButtons[i].querySelector('h2').classList.toggle('selected');
        //         }
        //     }
        // }
        checkIntersection();
    }

    const obsCallback4 = function (entries, observer) {
        entries.forEach((entry, index) => {
            isIntersecting[3] = entry.isIntersecting;
            // entry.target.classList.toggle("selected");
        });
        // for (let i=0; i<submenuButtons.length; i++) {
        //     if(submenuButtons[i].querySelector('h2')) {
        //         if(entries[i].isIntersecting) {
        //             alert(i);
        //             submenuButtons[i].querySelector('h2').classList.toggle('selected');
        //         }
        //     }
        // }
        checkIntersection();
    }

    const options = {
        root: null,
        threshold: 0.4,
        rootMargin: "-300px 0px -130px",
    }

    const observer = new IntersectionObserver(obsCallback, options);
    const observer2 = new IntersectionObserver(obsCallback2, options);
    const observer3 = new IntersectionObserver(obsCallback3, options);
    const observer4 = new IntersectionObserver(obsCallback4, options);
    observer.observe(inter1);
    observer2.observe(inter2);
    observer3.observe(inter3);
    observer4.observe(inter4);

    var newTechInsightSwiper = new Swiper('.nav-bar-submenu-main', {
        freeModeMomentum: false,
        watchSlidesVisibility: true,
        slidesPerView: 3.25,
        centeredSlides: false,
        mousewheel: {
            forceToAxis: true,
            invert: true
        },
        width: 250,
        breakpoints: {
            200: {
                slidesPerView: 1,
            },
        },
    });
});